export default {
      id: "ic_info_gray-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_info_gray-usage",
      toString: function () {
        return this.url;
      }
    }